import httpStore from "@/api/httpStore.js";

export function getBackupTableTaxjar() {
  return httpStore
    .get("taxjar/backup_table")
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function recreateBackupTableTaxjar() {
  return httpStore
    .get("taxjar/recreate_backup_table")
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function getOrdersByStatusTaxjar(status, page = 1, search = "") {
  const params = new URLSearchParams({
    page: page.toString()
  });

  if (search && search.trim()) {
    params.append("search", search.trim());
  }

  return httpStore
    .get(`taxjar/orders_by_status/${status}?${params.toString()}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function getOrderLogs(orderNumber) {
  return httpStore
    .get(`taxjar/order_logs/${orderNumber}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function sendSingleOrder(orderNumber) {
  return httpStore
    .get(`taxjar/send_order/${orderNumber}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function refundTaxjarOrder(orderNumber, amount) {
  return httpStore
    .post(`taxjar/refund_order/${orderNumber}`, { amount })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
